import Env from '../base/env.js'
import Channels from '../base/channels.js'

class MainnavTouch
{
    constructor()
    {
        if(Env.$mainNav == null) {
            return false
        }
        this.view = Env.$mainNav
        this.$triggers = Env.$body.querySelectorAll('.jsMainnav--trigger')
        this.$fill = this.view.querySelector('.fill')
        this.$primary = this.view.querySelectorAll('.primary-nav__menu li')
        this.$secondary = this.view.querySelectorAll('.secondary-nav__menu li')
        // Flags
        this.IS_ANIMATING = false
        // Fns
        this.events()
    }
    events()
    {
        var
        self = this

        for ( const e of this.$triggers ) {
            e.addEventListener('click',()=>{
                if(this.IS_ANIMATING == false)
                {
                    this.toggle()
                }
                return false;
            },false)
        }

        Channels.on('mainnav::close',()=>
        {
            this.close()
        })

        Channels.on('window::smartresize',()=>{
            if(Env.mobileCSS === false)
            {
                if(this.view != null) {
                    this.view.removeAttribute('style')
                }
            }
        })
    }

    getStatus()
    {
        return this.view.classList.contains('is--active')
    }

    close(funcStart=null,funcComplete=null)
    {
        this.out(
            ()=>{
                this.IS_ANIMATING = true
                this.view.classList.remove('is--active');
                Env.$html.classList.remove('mainnav--isOpened')
                Env.$html.classList.add('mainnav--isLeaving')
                if(typeof funcStart == 'function' || funcStart != null) funcStart()
            },
            ()=>{
                this.IS_ANIMATING = false
                Env.$html.classList.remove('mainnav--isLeaving')
                if(typeof funcComplete == 'function' || funcComplete != null) funcComplete()
            }
        )
    }

    in(funcStart='',funcComplete='')
    {

        let timeline = new TimelineLite({
            onStart:()=>{
                this.status = 'animating'
                if(typeof funcStart == 'function' || funcStart != null) funcStart()
            },
            onComplete:()=>{
                this.status = 'in'
                if(typeof funcComplete == 'function' || funcComplete != null) funcComplete()
            }
        })

        timeline.add([
            TweenLite.fromTo(this.$fill , .5,
                {
                    x : '-100%'
                },
                {
                    x: "0%",
                    ease: Power2.easeInOut,
                    delay: 0
                }
            ),
        ])
        timeline.add([
            TweenMax.staggerFromTo(this.$primary , .5,
                {
                    opacity: 0,
                    x : 50
                },
                {
                    opacity : 1,
                    x: 0,
                    ease: Power2.easeOut,
                    delay: 0
                },
                .03
            ),
            TweenMax.staggerFromTo(this.$secondary , .5,
                {
                    opacity: 0,
                    x : 25
                },
                {
                    opacity : 1,
                    x: 0,
                    ease: Power2.easeOut,
                    delay: 0.2
                },
                .03
            ),
        ],'-=.1')
    }

    out(funcStart='',funcComplete='')
    {

        let timeline = new TimelineLite({
            onStart:()=>{
                this.status = 'animating'
                if(typeof funcStart == 'function' || funcStart != null) funcStart()
            },
            onComplete:()=>{
                this.status = 'out'
                if(typeof funcComplete == 'function' || funcComplete != null) funcComplete()
            }
        })

        timeline.add([
            TweenMax.staggerTo(this.$primary , .5,
                {
                    opacity : 0,
                    x: -50,
                    ease: Power2.easeIn,
                    delay: 0
                },
                .03
            ),
            TweenMax.staggerTo(this.$secondary , .5,
                {
                    opacity : 0,
                    x: -25,
                    ease: Power2.easeIn,
                    delay: 0.1
                },
                .03
            ),
        ])
        timeline.add([
            TweenLite.to(this.$fill , .5,
                {
                    x: "-100%",
                    ease: Power2.easeInOut,
                    delay: 0
                }
            ),
        ],'-=.3')

    }

    toggle(_status)
    {
        if (typeof _status === 'undefined')
            _status = this.view.classList.contains('is--active')

        if(!!_status)
        {
            this.close()
        }
        else
        {
            this.in(
                ()=>{
                    this.IS_ANIMATING = true
                    this.view.classList.add('is--active');
                    Env.$html.classList.add('mainnav--isOpened')
                },
                ()=>{

                    this.IS_ANIMATING = false
                }
            )
        }
    };
}

export default MainnavTouch;


// WEBPACK FOOTER //
// ./resources/js/ui/mainnav-touch.js